import React from 'react';

function CustomFontImport(props) {
    const font = props.font || {};
    if (!font.href) {
        return null;
    }
    if (font.isHosted) {
        const html = `
            @font-face {
                font-family: '${font.name}';
                src: url(${font.href});
            }`;
        return <style dangerouslySetInnerHTML={{ __html: html }} />;
    } else {
        return <link href={font.href} rel="stylesheet" />
    }
}

function GoogleFontImport(props) {
    const config = props.config || {};
    if (!config.fonts || !config.fonts.linkHref || config.fonts.linkHref.length == 0) {
        return null;
    }
    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link rel="stylesheet" href={config.fonts.linkHref} />
        </>
    )
}

function PresentationFontImport() {
    const fontUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;700&display=swap';
    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link rel="stylesheet" href={fontUrl} />
        </>
    );
}

export default { Custom: CustomFontImport, Google: GoogleFontImport, Presentation: PresentationFontImport };